import api from '../api/axios/config';

export const fetchActivityLogs = async (requestId) => {
    try {
        const response = await api.get(`/activity-logs/${requestId}`);

        return { success: true, logs: response.data };
    } catch (error) {
        return { success: false, error: error.message };
    }
}